import Spinner from "react-bootstrap/Spinner";

export const ContentPageLoader = ({className = ''}) => (
  <div className={"content-page-loader "+className}>
    <Spinner animation="border" variant="primary" />
  </div>
);